// extracted by mini-css-extract-plugin
export default {"loadForm":"CommentForm_loadForm__v3X7C","group":"CommentForm_group__wvoEu","title":"CommentForm_title__tBRKj","text":"CommentForm_text__rv+ex","btn":"CommentForm_btn__ekzQr"};